import { KeyValue } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { StrictValuePipe } from '../../shared/pipes/strict-value.pipe';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class RadioButtonComponent implements OnInit, OnChanges {
  public selectList: Map<string, string> = new Map<string, string>();
  @Input() strictValueKey?: string;
  @Input() inline = false;
  @Input() value?: string;
  @Input() set controlName(value: string) {
    this._controlName = value;
    if (!this.name) {
      this.name = value;
    }
  }

  private _controlName?: string;

  get formControlName(): string {
    return this._controlName!;
  }

  @Input() name?: string;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(private _strictValuePipe: StrictValuePipe) {}

  ngOnInit(): void {}

  ngOnChanges(): void {
    this.setSelectList();
  }

  setSelectList(): void {
    this.selectList = this._strictValuePipe.strictValues(
      this.strictValueKey!,
      true
    )!;
  }

  onChange(value: string): void {
    this.value = value;
    this.valueChange.emit(this.value);
  }

  originalOrder(
    a: KeyValue<string, string>,
    b: KeyValue<string, string>
  ): number {
    return 0;
  }
}
